import React from "react";

import { Box, Typography } from "@mui/material";
import { CalculatorIcon } from "components/Icons/Icons";
import WorkspaceHeader from "components/Workspaces/WorkspaceHeader";

export default function ArcPlcCalculatorWorkspace() {
  return (
    <>
      <WorkspaceHeader
        title="ARC/PLC Projection Calculator"
        category={{
          title: "Calculators",
          icon: <CalculatorIcon />,
        }}
      />

      <Box sx={{ width: "100%", maxWidth: "800px", p: 2 }}>
        <Typography variant="h5" gutterBottom>
          ARC/PLC Projection Calculator
        </Typography>
        <Typography variant="body1" color="text.secondary">
          This calculator will help you project ARC/PLC payments. Implementation coming soon.
        </Typography>
      </Box>
    </>
  );
}
